import { render, staticRenderFns } from "./modalEditarProductos.vue?vue&type=template&id=449e18b3&scoped=true&"
import script from "./modalEditarProductos.vue?vue&type=script&lang=js&"
export * from "./modalEditarProductos.vue?vue&type=script&lang=js&"
import style0 from "./modalEditarProductos.vue?vue&type=style&index=0&id=449e18b3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "449e18b3",
  null
  
)

export default component.exports